import React from 'react'
import reviewImage from '../../assets/reviewImage.png'
import star from '../../assets/star.svg'
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import 'swiper/css/autoplay'
import SwiperCore, { Pagination, Autoplay } from "swiper";
SwiperCore.use([Autoplay]);


const CustomerReview = () => {

    const reviews = [
        {
            image: reviewImage,
            star: star,
            desc:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct',
            text2:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation'
        },
        {
            image: reviewImage,
            star: star,
            desc:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct',
            text2:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation'
        },
        {
            image: reviewImage,
            star: star,
            desc:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct',
            text2:'Kpoikpoimingi limited is a Nigerian Company founded in May 18,2017 with identification number 1414488 based on B13, Lousiana Garden City Dakwo District,Abuja Fct.Kpoikpoimingi limited is a company built on trust and transparency ,our core focus is building a healthy and ethical standard in fostering financial literacy in our world today.We are commited to providing exceptional customer service through technology and innovation'
        },
    ]

  return (
      <section  className='mt-[46px] md:mt-[116px] -z-50'>
          <h1 className='text mb-[46px] md:mb-[107px]'>Customer Reviews</h1>
          <Swiper
                pagination={{
                dynamicBullets: true,
                }}
                loop={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                }}
                modules={[Pagination, Autoplay]}
      >
          {reviews.map((review, i) => (
            <SwiperSlide className='bg-primary -z-50' key={i}>
                <div className='container xl:pl-[61px] xl:pr-[57px]'>
                    <div className=' h-[486px] md:h-[436px] xl:h-[350px] flex flex-col xl:flex-row px-[17px] pt-[53px] xl:pt-[89px] justify-center'>
                        <div className='w-[150px] h-[150px] xl:w-[200px] xl:h-[200px] xl:mr-[45px] mx-auto xl:mx-0 mb-[51px] hover:scale-105 duration-300 ease-in-out rounded-full border-[3px] border-solid border-white'>
                        <img className='w-[150px] h-[150px] xl:w-[200px] xl:h-[200px]' src={review.image} alt="/" />
                        </div>
                    <div className='mx-auto xl:mx-0'>
                        <div>
                            <img className='mb-[41px] mx-auto xl:mx-0 xl:ml-[-120px] ' src={review.star} alt="/" />
                        </div>
                        <div className=''>
                            <p className='md:w-[634px] text-center md:text-left md:h-[168px] md:hidden font-medium text-[14px] md:text-[16px] leading-[24px] tracking-[0.005em] text-white '>
                                {review.desc}
                            </p>
                            <p className='md:w-[634px] text-center md:text-left md:h-[168px] hidden md:block font-medium text-[14px] md:text-[16px] leading-[24px] tracking-[0.005em] text-white'>{review.text2}
                            </p>
                        </div>
                    </div>
                    </div>
                </div>
            </SwiperSlide>
          ))}
          </Swiper>
    </section>
  )
}

export default CustomerReview